import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = { class: "mt-6 d-flex align-center" }
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_pagination = _resolveComponent("v-pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("h2", null, "ダウンロード一覧", -1)),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        onClick: _ctx.listFiles,
        loading: _ctx.loading,
        color: "primary",
        variant: "outlined"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_icon, { start: "" }, {
            default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
              _createTextVNode("mdi-sync", -1)
            ]))]),
            _: 1
          }),
          _cache[4] || (_cache[4] = _createTextVNode(" 更新 ", -1))
        ]),
        _: 1
      }, 8, ["onClick", "loading"])
    ]),
    _createVNode(_component_v_card, {
      variant: "flat",
      class: "mt-6 pa-2",
      color: "grey-lighten-4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, { align: "center" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      items: _ctx.statusItems,
                      modelValue: _ctx.searchFilters.status,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchFilters.status) = $event)),
                      label: "ステータス",
                      variant: "outlined",
                      density: "compact",
                      disabled: _ctx.loading,
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["items", "modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_select, {
                      items: _ctx.categoryItems,
                      modelValue: _ctx.searchFilters.category,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searchFilters.category) = $event)),
                      label: "種別",
                      variant: "outlined",
                      density: "compact",
                      disabled: _ctx.loading,
                      "hide-details": "",
                      color: "primary"
                    }, null, 8, ["items", "modelValue", "disabled"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "3" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _ctx.listFilesFront,
                      loading: _ctx.loading,
                      color: "primary",
                      variant: "flat"
                    }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createTextVNode("検索 ", -1)
                      ]))]),
                      _: 1
                    }, 8, ["onClick", "loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h5", null, "計" + _toDisplayString(_ctx.list && _ctx.list.count ? _ctx.list.count : 0) + "件", 1)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_v_table, null, {
        default: _withCtx(() => [
          _cache[13] || (_cache[13] = _createElementVNode("thead", null, [
            _createElementVNode("tr", null, [
              _createElementVNode("th", null, "ステータス"),
              _createElementVNode("th", null, "更新日時"),
              _createElementVNode("th", null, "種別"),
              _createElementVNode("th", null, "ファイル名"),
              _createElementVNode("th", null, "ダウンロード")
            ])
          ], -1)),
          (_ctx.list)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list.data, (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", null, [
                      (item.status == 'completed')
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 0,
                            color: "success",
                            variant: "flat"
                          }, {
                            default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                              _createTextVNode("完了", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (item.status == 'inProgress')
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 1,
                            color: "warning",
                            variant: "flat"
                          }, {
                            default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                              _createTextVNode("処理中", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (item.status == 'failed')
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 2,
                            color: "error",
                            variant: "flat"
                          }, {
                            default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                              _createTextVNode("失敗", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (item.status == 'timeout')
                        ? (_openBlock(), _createBlock(_component_v_chip, {
                            key: 3,
                            color: "error",
                            variant: "flat"
                          }, {
                            default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                              _createTextVNode("タイムアウト", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.formatDate(item.updatedAt)), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.categoryItems.find((c) => c.value === (item.category ?? ""))?.title ?? ""), 1),
                    _createElementVNode("td", null, _toDisplayString(item.filename), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_v_btn, {
                        href: item.url ?? undefined,
                        disabled: item.status != 'completed',
                        loading: _ctx.loading,
                        color: "primary",
                        small: "",
                        variant: "flat"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_icon, { start: "" }, {
                            default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                              _createTextVNode("mdi-tray-arrow-down", -1)
                            ]))]),
                            _: 1
                          }),
                          _cache[12] || (_cache[12] = _createTextVNode(" ダウンロード ", -1))
                        ]),
                        _: 1
                      }, 8, ["href", "disabled", "loading"])
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      (_ctx.list && _ctx.list.count)
        ? (_openBlock(), _createBlock(_component_v_pagination, {
            key: 0,
            class: "mt-6",
            modelValue: _ctx.page,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.page) = $event)),
            onInput: _ctx.pageClick,
            length: Math.ceil(_ctx.list.count / _ctx.searchFilters.limit),
            "active-color": "primary"
          }, null, 8, ["modelValue", "onInput", "length"]))
        : _createCommentVNode("", true)
    ])
  ]))
}